import { connect } from "react-redux";
import { HelpContinue as Component, HelpContinueProps } from "./HelpContinue.component";
import { RootState } from "../../reducers";
import { getChatBotFeatureFlag } from "../../features";
import { logChatIntakeResults, openChatbot } from "../../action";

const mapStateToProps = (state: RootState) =>
  ({
    chatEnabled: getChatBotFeatureFlag(state),
  } as Pick<HelpContinueProps, "chatEnabled">);

export const HelpContinue = connect(mapStateToProps, {
  logChatIntakeResults,
  openChatbot,
} as Pick<HelpContinueProps, "logChatIntakeResults" | "openChatbot">)(Component);
